export const ANCHOR_SIDEBAR_HEADING_CLASSES = 'text-display-sm font-medium leading-tight'

/** The staircase and referenced strategies headings sit further apart in the accordion layout. */
export function anchorSidebarHeadingClasses(isAccordionLayout: boolean): string[] {
  if (isAccordionLayout) return [ANCHOR_SIDEBAR_HEADING_CLASSES, 'mb-4 mt-12']
  return [ANCHOR_SIDEBAR_HEADING_CLASSES, 'mt-9', 'mb-6']
}
